import { NOTIFICATIONS } from '../constants';
import { instance } from '../../axios';

const createNotificationAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: NOTIFICATIONS.CREATE_NOTIFICATION,
    });
    instance
      .post('/notification', body)
      .then((results) => {
        dispatch({
          type: NOTIFICATIONS.CREATE_NOTIFICATION_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: NOTIFICATIONS.CREATE_NOTIFICATION_FAILURE,
          payload: error,
        });
      });
  };
};

const updateNotificationAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: NOTIFICATIONS.UPDATE_NOTIFICATION,
    });
    instance
      .post('/notification/' + body.id, body)
      .then((results) => {
        dispatch({
          type: NOTIFICATIONS.UPDATE_NOTIFICATION_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: NOTIFICATIONS.UPDATE_NOTIFICATION_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteNotificationAction = (id, limit, offset, companyId) => {
  return (dispatch) => {
    dispatch({
      type: NOTIFICATIONS.DELETE_NOTIFICATION,
    });
    instance
      .delete('/notification/' + id)
      .then(() => {
        dispatch({
          type: NOTIFICATIONS.DELETE_NOTIFICATION_SUCCESS,
        });
        dispatch(getNotificationsAction(limit, offset, companyId));
      })
      .catch((error) => {
        dispatch({
          type: NOTIFICATIONS.DELETE_NOTIFICATION_FAILURE,
          payload: error,
        });
      });
  };
};

const getNotificationsAction = (limit, offset, companyId) => {
  return (dispatch) => {
    dispatch({
      type: NOTIFICATIONS.GET_NOTIFICATIONS,
    });
    const params = new URLSearchParams({ limit, offset });
    if (companyId) params.append('company_id', companyId);
    instance
      .get(`/notification?${params.toString()}`)
      .then((results) => {
        dispatch({
          type: NOTIFICATIONS.GET_NOTIFICATIONS_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: NOTIFICATIONS.GET_NOTIFICATIONS_FAILURE,
          payload: error,
        });
      });
  };
};

const getNotificationAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: NOTIFICATIONS.GET_NOTIFICATION,
    });
    instance
      .get(`/notification/${id}`)
      .then((results) => {
        dispatch({
          type: NOTIFICATIONS.GET_NOTIFICATION_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: NOTIFICATIONS.GET_NOTIFICATION_FAILURE,
          payload: error,
        });
      });
  };
};

const cleanNotificationAction = () => {
  return (dispatch) => {
    dispatch({
      type: NOTIFICATIONS.CLEAN_NOTIFICATIONS,
    });
  };
};

export {
  createNotificationAction,
  getNotificationsAction,
  cleanNotificationAction,
  deleteNotificationAction,
  getNotificationAction,
  updateNotificationAction,
};
